import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  editTimeLog() {
    Turbo.visit(
      "/time_logs/" +
        this.data.get("timelogid") +
        "/edit?return=" +
        window.location.pathname +
        window.location.search
    );
  }
}
